import identity from "lodash/identity"
import { useEffect } from "react"
import { Field, useField, useForm } from "react-final-form"
import InputMask from "react-input-mask"

import { InputControl } from "@trueskin-web/components"
import {
  composeValidators,
  mustBePostalCodeByCountry,
  required,
} from "@trueskin-web/functions"
import { getCountry } from "@trueskin-web/locales"
import { useTranslation } from "@trueskin-web/translations"

const PostalCode = ({ fieldName, className }) => {
  const { t } = useTranslation()
  const cookiesCountryCode = getCountry()
  const countryField = useField("country")
  const {
    input: { value: postalCodeValue },
  } = useField(fieldName)
  const form = useForm()

  const countryCode = countryField.input.value || cookiesCountryCode

  useEffect(() => {
    if (countryCode === "CH" && postalCodeValue?.length === 5) {
      form.resetFieldState(fieldName)
      form.change(fieldName, postalCodeValue.slice(0, -1))
    }
  }, [countryCode, postalCodeValue, fieldName, form])

  return (
    <Field
      data-testid="web-portal-shipping-form-postal-code"
      name={fieldName}
      component={InputControl}
      as={InputMask}
      mask={countryCode === "CH" ? "9999" : "99999"}
      maskPlaceholder=""
      required
      rounded
      validate={composeValidators(
        (value) => required(value, t("Generic.errors.postalCodeRequired")),
        mustBePostalCodeByCountry("country"),
        (_, allValues) => allValues.postalCodeError
      )}
      parse={identity}
      label={t("Start.Questionnaire.postalCode")}
      placeholder={t("Start.Questionnaire.postalCode")}
      className={className}
    />
  )
}

export default PostalCode
